export const backgroundTasksRouteLinks = {
    root: "/background-tasks",
    task: (backgroundTaskId: string) => ({
        root: `${backgroundTasksRouteLinks.root}/${backgroundTaskId}`,
    })
};